import Swiper, { Pagination } from 'swiper';

const sliders = document.querySelectorAll( '.js-team-slider' );
sliders.forEach(slider => {
    new Swiper(slider, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 23,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
        },
    });
});